import Log from "@/utils/Log";
import Vue from "vue";

const BellNotificationRenderer = () => require("@/components/datagrid/BellNotificationRenderer.vue");
const SingleLineTextRenderer = () => require("@/components/forms/renderers/SingleLineTextRenderer");
const PantoneRenderer = () => require("@/components/forms/renderers/PantoneRenderer");
const PantonePreviewRenderer = () => require("@/components/forms/renderers/PantonePreviewRenderer");
const ContainerNumberRenderer = () => require("@/components/forms/renderers/ContainerNumberRenderer");
const DataFromGusRenderer = () => require("@/components/forms/renderers/DataFromGusRenderer");
const SkuNumberRenderer = () => require("@/components/forms/renderers/SkuNumberRenderer");
const OrderNumberRenderer = () => require("@/components/forms/renderers/OrderNumberRenderer.vue");
const BrandingLabelsRenderer = () => require("@/components/forms/renderers/BrandingLabelsRenderer");
const DocumentsRenderer = () => require("@/components/forms/renderers/DocumentsRenderer");
const SizeRenderer = () => require("@/components/forms/renderers/SizeRenderer");
const IntegerRenderer = () => require("@/components/forms/renderers/IntegerRenderer");
const TextPillsListRenderer = () => require("@/components/forms/renderers/TextPillsListRenderer");
const StaticSelectRenderer = () => require("@/components/forms/renderers/StaticSelectRenderer");
const DateSelectRenderer = () => require("@/components/forms/renderers/DateSelectRenderer");
const ImageRenderer = () => require("@/components/forms/renderers/ImageRenderer");
const InspirationRenderer = () => require("@/components/forms/renderers/InspirationRenderer");
const DesignRenderer = () => require("@/components/forms/renderers/DesignRenderer");
const DescriptionByAIRenderer = () => require("@/components/forms/renderers/DescriptionByAIRenderer.vue");
const ImageGalleryPreviewRenderer = () => require("@/components/forms/renderers/ImageGalleryPreviewRenderer.vue");
const DepartmentRenderer = () => require("@/components/forms/renderers/DepartmentRenderer");
const GalleryRenderer = () => require("@/components/forms/renderers/GalleryRenderer");
const AttachmentsRenderer = () => require("@/components/forms/renderers/AttachmentsRenderer");
const CheckboxRenderer = () => require("@/components/forms/renderers/CheckboxRenderer");
const ColorPickerRenderer = () => require("@/components/forms/renderers/ColorPickerRenderer");
const FillInputsByAiRenderer = () => require("@/components/forms/renderers/FillInputsByAiRenderer");
const DecimalRenderer = () => require("@/components/forms/renderers/DecimalRenderer");
const DecimalCurrencyRenderer = () => require("@/components/forms/renderers/DecimalCurrencyRenderer");
const SelectActivityRenderer = () => require("@/components/forms/renderers/SelectActivityRenderer");
const ColorBoxClass = () => require("@/components/datagrid/ColorBoxClass");

const ImageRendererGrid = () => require("@/components/datagrid/ImageRendererGrid");
const AttachmentRendererGrid = () => require("@/components/datagrid/AttachmentRendererGrid");

const CheckboxIconClass = () => require("@/components/datagrid/CheckboxIconClass");
const TreeSelectActivityRenderer = () => require("@/components/forms/renderers/TreeSelectActivityRenderer");
const RowsGroupRenderer = () => require("@/components/forms/renderers/RowsGroupRenderer");
const DynamicValueRenderer = () => require("@/components/forms/renderers/DynamicValueRenderer");
const ValueAttributesGrid = () => require("@/components/datagrid/ValueAttributesGrid");
const MultiLineTextRenderer = () => require("@/components/forms/renderers/MultiLineTextRenderer");
const TextReadOnly = () => require("@/components/forms/renderers/TextReadOnly");
const FormattedTextRenderer = () => require("@/components/forms/renderers/FormattedTextRenderer.vue");
const EANRenderer = () => require("@/components/forms/renderers/EANRenderer");
const ListGrid = () => require("@/components/datagrid/ListGrid");

export let TRANSLATABLE_TEXT_RENDERERS = [
    'RENDERER_SINGLE_LINE_TEXT',
    'RENDERER_FILL_INPUTS_BY_AI',
    'RENDERER_MULTI_LINE_TEXT',
    'RENDERER_FORMATTED_TEXT',
    'RENDERER_AI_DESCRIPTION'
];

export let TRANSLATABLE_CURRENCY_RENDERERS = [
    'RENDERER_DECIMAL_CURRENCY_INPUT',
];

let Renderers = {
    RENDERER_SINGLE_LINE_TEXT: SingleLineTextRenderer,
    RENDERER_PANTONE: PantoneRenderer,
    RENDERER_PREVIEW_PANTONE: PantonePreviewRenderer,
    RENDERER_FILL_INPUTS_BY_AI: FillInputsByAiRenderer,
    RENDERER_IMAGE_GALLERY_PREVIEW: ImageGalleryPreviewRenderer,
    RENDERER_CONTAINER_NUMBER: ContainerNumberRenderer,
    RENDERER_DATA_FROM_GUS: DataFromGusRenderer,
    RENDERER_SKU_NUMBER: SkuNumberRenderer,
    RENDERER_ORDER_NUMBER: OrderNumberRenderer,
    RENDERER_LABELS_RENDERER: BrandingLabelsRenderer,
    DOCUMENTS_RENDERER: DocumentsRenderer,
    RENDERER_SIZE: SizeRenderer,
    RENDERER_MULTI_LINE_TEXT: MultiLineTextRenderer,
    RENDERER_FORMATTED_TEXT: FormattedTextRenderer,
    RENDERER_EAN: EANRenderer,
    RENDERER_INT_INPUT: IntegerRenderer,
    RENDERER_PILLS_LIST: TextPillsListRenderer,
    RENDERER_STATIC_SELECT: StaticSelectRenderer,
    RENDERER_DATE_SELECT: DateSelectRenderer,
    RENDERER_CHECKBOX_SELECT: CheckboxRenderer,
    RENDERER_IMAGE: ImageRenderer,
    RENDERER_INSPIRATION: InspirationRenderer,
    RENDERER_DESIGN: DesignRenderer,
    RENDERER_AI_DESCRIPTION: DescriptionByAIRenderer,
    RENDERER_DEPARTMENT: DepartmentRenderer,
    RENDERER_GALLERY: GalleryRenderer,

    RENDERER_ATTACHMENTS: AttachmentsRenderer,
    RENDERER_COLOR_PICKER_SELECT: ColorPickerRenderer,
    RENDERER_DECIMAL_INPUT: DecimalRenderer,
    RENDERER_DECIMAL_CURRENCY_INPUT: DecimalCurrencyRenderer,
    RENDERER_SELECT_ACTIVITY: SelectActivityRenderer,
    RENDERER_SELECT_TREE_NODE: TreeSelectActivityRenderer,
    RENDERER_ROWS_GROUP: RowsGroupRenderer,
    RENDERER_DYNAMIC_FIELD: DynamicValueRenderer,
    RENDERER_TEXT_READ_ONLY: TextReadOnly,

    GRID_COLOR: ColorBoxClass,
    GRID_IMAGE: ImageRendererGrid,
    GRID_CHECKBOX: CheckboxIconClass,
    RENDERER_BELL_NOTIFICATION: BellNotificationRenderer,
    GRID_VALUE_ATTRIBUTES: ValueAttributesGrid,
    GRID_LIST: ListGrid,
    GRID_ATTACHMENTS: AttachmentRendererGrid

};


let renderersInitialized = false;

export async function initRenderers() {
    if (renderersInitialized) {
        return;
    }
    renderersInitialized = true;

    for (const k in Renderers) {
        Renderers[k] = (await Renderers[k]()).default;
    }
}

/** Map<String, Class> */
let componentStore = null;

export function getComponentClass(name, router) {
    if (componentStore) {
        if (componentStore.has(name)) {
            return componentStore.get(name);
        }
        Log.fatal("Renderer component not found:" + name);
        throw new Error("Renderer component not found:" + name);
    }

    componentStore = new Map();
    for (const name in Renderers) {
        let ComponentClass = Vue.extend({...Renderers[name], router});
        componentStore.set(name, ComponentClass);
    }

    return getComponentClass(name);
}

export default Renderers;